import { Box } from "@mui/material";
import { eslColors } from "./eslColors";

interface IEslColorPaletteProps {
  onColorSelect: (color: string) => void;
  selectedColor: string | undefined;
}

const EslColorPalette = ({ onColorSelect, selectedColor }: IEslColorPaletteProps) => {
  return (
    <Box sx={{
      display: "flex",
      gap: 1,
    }}>
      {eslColors.map((color) => (
        <Box
          key={color.target}
          sx={{
            display: "inline-block",
            width: "30px",
            height: "30px",
            backgroundColor: color.preview,
            border: "1px solid gray",
            cursor: "pointer",
            ":hover": {
              scale: 1.2
            },
            scale: selectedColor === color.target ? 1.2 : 1
          }}
          onClick={() => onColorSelect(color.target)}
        />
      ))}
    </Box>
  );
}

export default EslColorPalette;
